export default __webpack_public_path__ + "static/media/telegram.c0ae5456.svg";